import ProtectedRoute from 'components/ProtectedRoute'
import Lab from './Lab'

const InsightsLab = () => {
  return (
    <div className="full-height grey-05-bkg">
      <ProtectedRoute
        accessType="access"
        redirect="/"
        resource="InsightsLab"
        exact
        path="/insights_lab"
        component={Lab}
      />
    </div>
  )
}

export default InsightsLab
